import { isNotPrimitive, isPrimitive } from '@repo/alt/common/Utils/Data.js'

import type { RawApiErrors } from './types'

export const checkIsApiError = (error: unknown) => {
  if (isPrimitive(error)) {
    return false
  }

  return Boolean((error as Record<string, any>).status)
}

export function parseApiError(error: unknown): RawApiErrors | undefined {
  if (
    isNotPrimitive(error)
    && 'response' in error
    && isNotPrimitive(error.response)
    && 'data' in error.response
    && error.response.data
    && checkIsApiError(error.response.data)
  ) {
    return error.response.data as RawApiErrors
  }

  if (
    isNotPrimitive(error)
    && 'response' in error
    && checkIsApiError(error.response)
  ) {
    return error.response as RawApiErrors
  }

  if (checkIsApiError(error)) {
    return error as RawApiErrors
  }
}
